import type { ZapiAction } from '@weft/zapi-types';
import { CUSTOMERS_IDS_QUERY_PARAM, METERS_IDS_QUERY_PARAM, OPTIONAL_END_TIME_QUERY_PARAM, OPTIONAL_START_TIME_QUERY_PARAM, PAGINATION_QUERY_PARAMETERS } from '../../../api-definition-params';
import { GET_LATEST_EVENTS_PATH } from './get-latest-events-path';
import { GetLatestEventsResponseSchema } from './get-latest-events-response-schema';

export const GET_LATEST_EVENTS_ACTION = {
  method: 'get',
  codeGenerationSettings: {
    actionText: 'get-latest-events',
  },
  queryParams: {
    ...PAGINATION_QUERY_PARAMETERS,
    [OPTIONAL_END_TIME_QUERY_PARAM.name]: OPTIONAL_END_TIME_QUERY_PARAM,
    [OPTIONAL_START_TIME_QUERY_PARAM.name]: OPTIONAL_START_TIME_QUERY_PARAM,
    [METERS_IDS_QUERY_PARAM.name]: METERS_IDS_QUERY_PARAM,
    [CUSTOMERS_IDS_QUERY_PARAM.name]: CUSTOMERS_IDS_QUERY_PARAM,
  },
  response: {
    name: 'GetLatestEventsResponse',
    schema: GetLatestEventsResponseSchema,
  },
  path: GET_LATEST_EVENTS_PATH,
} satisfies ZapiAction;

export type GetLatestEventsAction = typeof GET_LATEST_EVENTS_ACTION;